import { z } from 'zod'

// Shape of globalConfigs.editor_config — the cfg-driven rich-text editor
// config, resolved env-aware by the backend (get_editor_config) from
// cfg.app_config (config_group='editor'). The CKEditor wrapper consumes this;
// changing the toolbar, fonts, firm Styles or merge-field list is a cfg edit,
// not a code change (plan §6.4).
//
// Permissive by design (.passthrough() + loose arrays): the editor config
// evolves and is consumed by the wrapper, not deeply enforced here. `engine`
// drives the compose-body Jodit↔CKEditor toggle.

export const EditorMergeFieldSchema = z
  .object({
    id: z.string(),
    label: z.string(),
    token: z.string(),
    tooltip: z.string().optional().default('')
  })
  .passthrough()

export const EditorStyleDefinitionSchema = z
  .object({
    name: z.string(),
    element: z.string(),
    classes: z.array(z.string()).optional().default([])
  })
  .passthrough()

export const EditorConfigSchema = z
  .object({
    engine: z.string().optional().default('jodit'),
    license_key: z.string().optional().default(''),
    toolbar: z.array(z.any()).optional().default([]),
    // zod v4: z.record requires (keyType, valueType) — z.record(z.any()) throws
    // at parse time, which would break the whole global-configs validation.
    fonts: z.record(z.string(), z.any()).optional().default({}),
    styles: z.array(EditorStyleDefinitionSchema).optional().default([]),
    merge_fields: z.array(EditorMergeFieldSchema).optional().default([])
  })
  .passthrough()

export type EditorConfig = z.infer<typeof EditorConfigSchema>
export type EditorMergeField = z.infer<typeof EditorMergeFieldSchema>
export type EditorStyleDefinition = z.infer<typeof EditorStyleDefinitionSchema>
